import { render, staticRenderFns } from "./ExternalPoll.vue?vue&type=template&id=684e2184&scoped=true"
import script from "./ExternalPoll.vue?vue&type=script&lang=js"
export * from "./ExternalPoll.vue?vue&type=script&lang=js"
import style0 from "./ExternalPoll.vue?vue&type=style&index=0&id=684e2184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e2184",
  null
  
)

export default component.exports